import type { CSSProperties } from 'react';
import './Loader.css';

export const types = [
    'in-form',
    'in-form blue',
    'in-button',
    'medium-blue',
    'in-button red',
    'in-button blue',
    'in-button blue left',
    'medium-blue',
    'blue',
    'loading-more',
    'none',
] as const satisfies readonly string[];

export type LoaderTypes = (typeof types)[number];

type Props = {
    /** pass in either 'in-form', 'in-button', 'medium-blue', 'in-button red', 'in-button-blue', 'medium-blue', 'blue', 'loading-more'. Defaults to 'in-button blue' */
    type?: LoaderTypes;
    /** pass in CSS custom styles */
    style?: CSSProperties;
};

const Loader = ({ type, style }: Props) => (
    <div style={style} className={`small-loader ${type ?? ''}`} data-testid="button-loader">
        <svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle className="loader-circle" cx="9.5" cy="9.5" r="7.5" strokeOpacity="0.5" strokeWidth="2.5" />
            <path className="loader-focus" d="M9.5 17C5.35786 17 2 13.6421 2 9.5" strokeWidth="2.5" />
        </svg>
    </div>
);

Loader.defaultProps = {
    type: 'in-button blue' satisfies LoaderTypes,
};

export default Loader;
